import React from "react";
import styled from "styled-components";
import { Link } from "react-feather";

const CustomLink = styled.a`
  width: fit-content;
  height: 30px;
  padding: 0px 8px;
  margin-right: auto;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  text-decoration: none;
  color: inherit;
  cursor: pointer;
  background: white;
  transition: 200ms ease-in;

  span {
    color: slategrey;
    font-weight: 500;
    font-size: 12px;
    padding-left: 2px;
    padding-right: 2px;
  }

  svg {
    color: slategrey;
    transition: color 200ms;
  }

  &:hover {
    background: aliceblue;

    svg {
      color: #337ab7;
    }

    span {
      color: #337ab7;
      font-weight: 600;
    }
  }
`;

const inferPrefixFromEnvVars = () => {
  if (
    process.env.NODE_ENV !== "production" ||
    typeof process.env.REACT_APP_API_DOMAIN !== "string"
  ) {
    return "http://localhost:8000";
  }

  if (process.env.REACT_APP_API_DOMAIN.includes("staging")) {
    return "https://staging.withspiffy.com";
  }
  return "https://portal.withspiffy.com";
};

const ExternalLinkDjango = ({ companyId }) => {
  const prefix = inferPrefixFromEnvVars();
  const href = `${prefix}/adv/company/company/${companyId}/change/`;
  return (
    <CustomLink href={href} target="_blank" rel="noopener noreferrer">
      <Link height={14} />
      <span>Link To Django Admin</span>
    </CustomLink>
  );
};

export default ExternalLinkDjango;
